export default __webpack_public_path__ + "static/media/nutri3.d4e76e7e.jpg";